// extracted by mini-css-extract-plugin
export var image = "TalkMessageImage-module--image--0715b";
export var imageContainer = "TalkMessageImage-module--imageContainer--0b764";